"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("./client");
var LOCAL_STORAGE_QUEUE = 'elogjs-events';
function get() {
    try {
        var queue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_QUEUE));
        if (Array.isArray(queue)) {
            return queue;
        }
        return [];
    }
    catch (e) {
        return [];
    }
}
function drain() {
    var events = get();
    try {
        window.localStorage.removeItem(LOCAL_STORAGE_QUEUE); // race condition
    }
    catch (e) { }
    if (events.length !== 0) {
        client_1.default.post(events, 'events');
    }
}
function save(queue) {
    try {
        localStorage.setItem(LOCAL_STORAGE_QUEUE, JSON.stringify(queue));
    }
    catch (e) {
        // Some browsers will raise a QuotaExceededError in private browsing mode
        // remove key in case queue is in bad state for some reason
        localStorage.removeItem(LOCAL_STORAGE_QUEUE);
    }
}
exports.default = {
    drain: drain,
    get: get,
    save: save,
};



//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.ecs-deploy.production/build/src/node_modules/@reverbdotcom/elog/dist/persisted-queue.js
// module id = xRt3
// module chunks = 20